import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Dropdown from 'react-toolbox/lib/dropdown'
import LastUpdated from 'components/display/LastUpdated'
import { compose } from 'recompose'

import styles from './styles.scss'

const RevisionDropdown = ({ value, label, source, createdAt, createdBy, onChange }) => {
  return (
    <div styleName='revisionDropdown'>
      <Dropdown
        auto
        onChange={onChange}
        label={label}
        source={source}
        value={value}
      />
      <LastUpdated created name={createdBy} date={createdAt} className={styles.lastUpdated}/>
    </div>
  )
}

RevisionDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  source: PropTypes.array.isRequired,
  value: PropTypes.number,
}

const withStyle = CSSModules(styles)
export default compose(
  withStyle
)(RevisionDropdown)
